/* eslint-disable no-param-reassign */
/* eslint-disable no-console */

import Configuration from '@/js/Configuration';

export default {
  install(Vue) {
    Vue.prototype.$isAccessTokenValid = () => {
      if (
        Vue.cookie.get('accessToken') === '' ||
        Vue.cookie.get('accessToken') === null ||
        Vue.cookie.get('accessToken') === undefined
      ) {
        return false;
      }

      const token = Vue.prototype.$jwtDecode(Vue.cookie.get('accessToken'));
      if (token.exp * 1000 <= Date.now()) {
        return false;
      }

      return true;
    };

    Vue.prototype.$deleteCookie = () => {
      Vue.cookie.set('accessToken', '', 0);
      Vue.cookie.set('refreshToken', '', 0);
    };

    Vue.prototype.$refreshToken = async () => {
      if (
        Vue.cookie.get('accessToken') === '' ||
        Vue.cookie.get('accessToken') === null ||
        Vue.cookie.get('accessToken') === undefined
      ) {
        return false;
      }
      if (
        Vue.cookie.get('refreshToken') === '' ||
        Vue.cookie.get('refreshToken') === null ||
        Vue.cookie.get('refreshToken') === undefined
      ) {
        return false;
      }

      try {
        const uID = Vue.prototype.$jwtDecode(Vue.cookie.get('accessToken')).uID;
        const res = await Vue.axios.get(
          `${Configuration.value(
            'CACCOUNT_ADDRESS',
          )}/api/v1/caccount/user/${uID}/token`,
          {
            headers: {
              Authorization: `Bearer ${Vue.cookie.get('refreshToken')}`,
            },
          },
        );
        if (res.status !== 200) {
          throw new Error(`Response status is "${res.status}"`);
        }
        if (res.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${res.data.resultCode}"`);
        }

        Vue.cookie.set('accessToken', res.data.accessToken);
      } catch (e) {
        console.error(e);
        return false;
      }

      return true;
    };
  },
};



// WEBPACK FOOTER //
// ./src/js/Util.js